/**
 * // Class Obj: 対象の要素のCSSクラスを操作
 */
export class ClassListController
{
  public mTarget: HTMLElement | null;

  /**
   * // Constructor: 対象となる要素を受け取る
   *
   * @param {HTMLElement} target_selector:HTMLElement 対象の要素のセレクタを指定
   */
  constructor(target_selector: HTMLElement | null = null)
  {
    this.mTarget = target_selector;
  }

  /**
   * // Method: 対象の要素のCSSクラスを切り替える
   *
   * @param remove_class 削除するCSSクラス名
   * @param add_class 追加するCSSクラス名
   */
  public switchClass(remove_class: string, add_class: string): void
  {
    if (this.mTarget)
    {
      this.mTarget.classList.remove(remove_class);
      this.mTarget.classList.add(add_class);
    }
  }
}
